import { Menu as AntdMenu, type MenuProps } from 'antd'

export function Menu(props: MenuProps) {
  return <AntdMenu {...props} />
}
